import { buildPageHead } from "@lib/meta"
import type { SupportedLocale } from "@site-types/content"
import { metadataDefaults, pageLabels } from "./routeLabels"

type RouteHeadOptions = {
  locale: SupportedLocale
  page: string
  path: string
  title?: string
  description?: string
  image?: string
  type?: "article" | "website"
}

export function localizedRouteHead({
  locale,
  page,
  path,
  title,
  description,
  image,
  type,
}: RouteHeadOptions) {
  const labels = pageLabels(locale, page)
  const metadata = metadataDefaults(locale)
  const resolvedTitle = title || labels.layoutTitle || metadata.ogTitleFallback
  const resolvedDescription =
    description ||
    labels.description ||
    labels.pageTitle ||
    labels.layoutTitle ||
    metadata.descriptionFallback
  return buildPageHead({
    locale,
    path,
    title: resolvedTitle,
    description: resolvedDescription,
    ogTitle: title ? undefined : labels.ogTitle || metadata.ogTitleFallback,
    ogDescription: description ? undefined : labels.ogDescription || resolvedDescription,
    image: image || metadata.ogImageFallback,
    type,
    author: metadata.author,
    publisher: metadata.publisher,
    siteName: metadata.siteName,
    twitterCard: metadata.twitterCard,
    twitterSite: metadata.twitterSite,
    twitterTitle: metadata.twitterTitle,
    twitterImage: metadata.twitterImage,
  })
}
